import { styled } from "@mui/styles"

import { List } from "../../.."

export const Wrapper = styled("div")({
  marginBottom: "13px",
  alignSelf: "baseline",

  "&:last-child": {
    marginBottom: 0,
  },
})

export const TitleWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  color: "#4b444a",
  marginBottom: ".5rem",
})

export const Adornment = styled("span")({
  marginRight: "1rem",
})

export const Title = styled("span")({
  fontSize: "1.6rem",
  fontWeight: "bold",
})

export const PropertyListRoot = styled(List.Root)({
  "& .MuiSvgIcon-root": {
    color: "#6b546a",
    fontSize: "2rem",
    marginRight: "1.4rem",
    padding: 0,
  },
  "&.MuiList-root": {
    "& .MuiListItem-root": {
      fontSize: "1.4rem",
    },
    padding: 0,
  },
  backgroundColor: "#f9f9f9",
  border: "1px solid #ececec",
  borderRadius: 4,
  color: "#333333",
  minWidth: "590px",
  width: "100%",
})

export const BoldText = styled("span")({ fontSize: "1.4rem", fontWeight: "bold" })

export const ItemWrapper = styled("span")({ display: "flex" })

export const StyledListItem = styled(List.Item)({
  "&.MuiListItem-root": {
    paddingBottom: 0,
    paddingTop: 0,
  },
  "&>.MuiListItemText-root": {
    margin: 0,
  },
  color: "#3333333",
})

export const Column = styled("span")({
  "&:first-child": {
    "& .MuiSvgIcon-root": {
      color: "#333333",
    },
    borderRight: "1px solid #0000001f",
    color: "#333333",
    marginRight: "1rem",
    paddingBottom: "1.5rem",
    paddingTop: "1.5rem",
  },
  alignItems: "center",
  display: "flex",
  width: "50%",
})
